export const pdfPreviewMaxWidth = 800;

export const options = {
  cMapUrl: '/cmaps/',
  standardFontDataUrl: '/standard_fonts/',
};
